import { MouseEvent } from 'react';
import { Grid } from '@material-ui/core';
import { Box, BoxTexts, BoxQuantitys, Title } from './ContentStock';
import { BiChevronRight } from 'react-icons/bi';

interface BoxStockProps {
  name: string;
  address: string;
  quantity: number;
  onClick?(e: MouseEvent<HTMLElement>): void;
  stockCd?: string;
}

function BoxStock({ name, address, quantity, onClick, stockCd }: BoxStockProps) {

  if (quantity < 1) {
    return <></>
  }
  const renderName: string = stockCd ? `CD ${name}` : name;

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Box onClick={onClick} >
        <BoxTexts >
          <Title fontWeight='bold' >{renderName}</Title>
          {stockCd ? <Title fontSize={18} paddingTop={10} >{stockCd}</Title> : <Title fontSize={12} fontWeight='400' lineHeight={18} paddingTop={4}>{address} </Title>}
        </BoxTexts>
        {!stockCd && (
          <BoxQuantitys>
            <BiChevronRight size={40} />
          </BoxQuantitys>
        )}
      </Box>
    </Grid>
  );
}

export default BoxStock;
